import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <h3 className="text-xl font-heading text-accent-500 mb-4">{t('site.name')}</h3>
            <p className="text-sm text-foreground-300 leading-relaxed">
              {t('site.description')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
                {t('nav.home')}
              </Link>
              <Link to="/category/daily" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
                {t('nav.categories')}
              </Link>
              <Link to="/about" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
                {t('nav.about')}
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/daily" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
                {t('category.daily')}
              </Link>
              <Link to="/category/match" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
                {t('category.match')}
              </Link>
              <Link to="/category/storage" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
                {t('category.storage')}
              </Link>
              <Link to="/category/tips" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
                {t('category.tips')}
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">{t('footer.copyright')}</p>
          <p className="text-xs text-foreground-500 font-heading">{t('footer.tagline')}</p>
        </div>
      </div>
    </footer>
  );
}